module.exports = __webpack_public_path__ + "img/cg_logo.73756431.png";